{
  "dss": {
    "button": {
      "back": "Назад",
      "cancel": "Скасувати",
      "close": "Закрити",
      "confirmDelete": "Так, видалити",
      "continue": "Продовжити",
      "logout": "Вийти",
      "passwordReset": "Скидання пароля",
      "save": "Зберегти",
      "verify": "Підтвердити"
    },
    "error": {
      "403": "У вас немає доступу до цієї сторінки.",
      "404": "Ця сторінка не існує.",
      "generic": "Сталася помилка. Будь ласка, спробуйте пізніше.",
      "invalidConfirmationLink": "Посилання для підтвердження прострочене або недійсне.",
      "throttling": "Занадто багато спроб. Операцію тимчасово заблоковано.",
      "title": "Помилка",
      "title403": "Доступ заборонено",
      "title404": "Не знайдено"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Політика конфіденційності",
      "terms": "Умови та положення"
    },
    "label": {
      "CRMAccountNumber": "Номер облікового запису CRM",
      "contact": "Контакт",
      "email": "Електронна пошта",
      "faq": "FAQ",
      "female": "Пані",
      "firstname": "Ім'я",
      "help": "Довідка",
      "language": "Мова",
      "lastname": "Прізвище",
      "male": "Пан",
      "needHelp": "Потрібна допомога?",
      "newPassword": "Новий пароль",
      "newPassword2": "Підтвердіть новий пароль",
      "oldPassword": "Поточний пароль",
      "organization": "Організація",
      "password": "Пароль",
      "required": "обов'язково",
      "salutation": "Звертання",
      "select": "Будь ласка, оберіть"
    },
    "lang": {
      "de": "Німецька"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Підтвердити реєстрацію",
        "wait": "Будь ласка, зачекайте завершення підтвердження облікового запису."
      },
      "otp": {
        "btnResend": "Надіслати лист із кодом повторно",
        "msg": {
          "invalidOTP": "Введений одноразовий пароль недійсний.",
          "resendFail": "Не вдалося повторно надіслати код. Будь ласка, спробуйте пізніше."
        },
        "spamDetail": "Перевірте вхідні та папку спам на наявність листа від STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Не отримали лист?",
        "subtitle": "Щоб продовжити, потрібно підтвердити адресу електронної пошти.",
        "title": "Підтвердьте свій обліковий запис",
        "txtVerifyMail": "Будь ласка, введіть новий код підтвердження, який ми надіслали на адресу {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Немає що оновлювати.",
          "updateError": "Не вдалося оновити персональні дані.",
          "updated": "Персональні дані оновлено.",
          "userLoadErr": "Помилка під час завантаження даних користувача. Будь ласка, спробуйте пізніше."
        },
        "secOrganization": "Організація",
        "secPersonal": "Особисте",
        "secSettings": "Переважні налаштування",
        "title": "Особиста інформація"
      },
      "postPwSet": {
        "info": "Тепер ви можете використовувати новий пароль.",
        "link_name": "Перейти до Self-Service",
        "link_url": "/user/ui/",
        "title": "Ваш пароль змінено"
      },
      "resetPW": {
        "title": "Скиньте свій пароль"
      },
      "security": {
        "2fa": {
          "availableMethods": "Доступні методи 2FA:",
          "info": "Двофакторна автентифікація (2FA) — це функція безпеки, яка додає додатковий рівень захисту вашому обліковому запису. Замість одного логіна і пароля потрібно використовувати два методи входу.",
          "method": {
            "email": "Електронна пошта",
            "emailDesc": "Отримуйте одноразові коди електронною поштою для завершення запитів автентифікації.",
            "oath": {
              "add": {
                "button": "Зареєструвати додаток Authenticator"
              }
            }
          }
        },
        "authenticator": "Додаток Authenticator",
        "infoFederatedAccount": "Цей обліковий запис керується постачальником ідентифікації вашої організації, тому пароль не можна змінити тут. Щоб змінити пароль, увійдіть через сторінку входу вашої організації або зверніться до свого ІТ-адміністратора.",
        "lastUse": "Востаннє використано: {0}.",
        "msg": {
          "invalidPassword": "Вказано недійсний поточний пароль.",
          "passwordAlreadyUsed": "Не можна повторно використовувати останні 5 паролів.",
          "pwUpdateError": "Під час спроби зміни пароля сталася помилка.",
          "pwUpdated": "Пароль змінено."
        },
        "noDevice": "Не налаштовано",
        "oathAdd": {
          "appInfo": "Щоб спростити вхід до STIHL, ви можете використовувати додатки Authenticator, такі як {0}, {1}, {2} тощо, для генерації одноразових паролів, які використовуються як другий фактор під час входу.<br/>Якщо ви втратили або забули свій мобільний пристрій, ви завжди можете використати код 2FA, надісланий електронною поштою.<br/><br/>Дотримуйтеся наведених нижче інструкцій, щоб налаштувати пристрій автентифікації.",
          "badCode": "Недійсний код, будь ласка, спробуйте ще раз.",
          "error": "Сталася помилка під час реєстрації пристрою автентифікації.",
          "headScan": "1. Скануйте QR-код вашим додатком Authenticator",
          "headVerify": "2. Підтвердьте код",
          "infoKey": "ключ налаштування",
          "infoKeyTitle": "Ваш секрет двофакторної автентифікації",
          "infoScanBottom": "Не вдається сканувати? Ви можете використати {0}, щоб вручну налаштувати додаток Authenticator.",
          "infoVerify": "Введіть код, згенерований вашим додатком Authenticator.",
          "success": "Ваш пристрій автентифікації зареєстровано. Тепер ви можете використовувати його для входу.",
          "title": "Зареєструйте ваш пристрій двофакторної автентифікації"
        },
        "oathDelete": {
          "error": "Сталася помилка під час видалення пристрою автентифікації.",
          "success": "Пристрій автентифікації видалено."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey — це пари криптографічних ключів (публічного і приватного), які зберігає автентифікатор під вашим контролем. Автентифікатор може довести, що користувач присутній і має право використовувати passkey. Авторизація підтверджується PIN-кодом, кодом, біометрією або паролем пристрою — залежно від можливостей і конфігурації автентифікатора. Автентифікатори бувають різних типів: iPhone чи Android-пристрій, Windows Hello, апаратний ключ безпеки FIDO2 або менеджер паролів.",
            "info2": "Коли ви входите до STIHL за допомогою passkey, ваш автентифікатор використовує криптографію з відкритим ключем, щоб довести вашу особу STIHL без надсилання самого passkey. Passkey прив'язані до домену вебсайту, наприклад stihl-sso.com, і вимагають безпечного з'єднання, що означає, що браузер відмовить в автентифікації на схожому фішинговому сайті. Ці властивості роблять passkey дуже стійкими до фішингу та значно складнішими для атак, ніж SMS або TOTP 2FA.",
            "info3": "Хмарні сервіси passkey дозволяють синхронізувати ключі між пристроями (наприклад, пристроями Apple, Android або менеджерами паролів), щоб їх можна було використовувати в більшій кількості місць і щоб вони рідше втрачалися. Налаштувавши синхронізований passkey на одному пристрої, ви зможете використовувати його на кількох пристроях, що використовують ту саму службу. Наприклад, якщо ви зареєструєте passkey у своєму обліковому записі iCloud за допомогою Touch ID на MacBook, то зможете використовувати цей passkey з розпізнаванням обличчя, відбитком пальця, PIN-кодом або паролем пристрою на кількох пристроях, пов'язаних з тим самим обліковим записом iCloud.",
            "title": "Про Passkeys"
          },
          "add": {
            "button": "Додати новий Passkey",
            "error": "Сталася помилка під час додавання нового passkey.",
            "success": "Додано новий passkey."
          },
          "delete": {
            "button": "Видалити Passkey",
            "error": "Сталася помилка під час видалення цього passkey.",
            "success": "Passkey видалено."
          },
          "edit": {
            "error": "Сталася помилка під час збереження назви passkey.",
            "name": "Назва Passkey",
            "success": "Назву passkey оновлено.",
            "title": "Дайте вашому Passkey назву, щоб відрізняти його від інших"
          },
          "info": "Passkey — це проста і безпечна альтернатива паролям, що підтверджує вашу особу за допомогою дотику, розпізнавання обличчя, пароля пристрою або PIN-коду.",
          "none": "Жодного Passkey не налаштовано.",
          "reallyDelete": "Ви впевнені, що хочете видалити Passkey?",
          "registeredPasskeys": "Ваші зареєстровані Passkey:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Ви впевнені, що хочете видалити пристрій автентифікації?",
        "secMFA": "Двофакторна автентифікація",
        "secPwdChange": "Змінити пароль",
        "title": "Безпека"
      },
      "setPW": {
        "acceptTC": "Будь ласка, підтвердіть наші {terms} і прочитайте нашу {privacy}.",
        "killSSO": "Анулювати всі активні сесії",
        "msg": {
          "tokenExpired": "Посилання або код для пароля прострочені. Будь ласка, перейдіть за посиланням, щоб скинути пароль: {link}."
        },
        "privacy": "Політика конфіденційності даних",
        "terms": "Умови та положення",
        "title": "Введіть новий пароль"
      }
    },
    "validations": {
      "hasDigit": "Повинен містити цифри",
      "hasLowercase": "Повинен містити малі літери",
      "hasSpecial": "Повинен містити спеціальні символи: {chars}",
      "hasUppercase": "Повинен містити великі літери",
      "invalidCharacters": "Містить недопустимі символи",
      "maxLength": "Максимум {max} символів",
      "minLength": "Мінімум {min} символів",
      "notSameAsEmail": "Занадто схожий на адресу електронної пошти",
      "onlyValidCharactersAllowed": "Дозволені лише літери, цифри та пробіли.",
      "required": "Обов'язкове поле",
      "sameAsPassword": "Паролі не збігаються",
      "tcAccepted": "Будь ласка, підтвердіть наші умови та положення.",
      "validEmail": "Недійсна адреса електронної пошти.",
      "validOTP": "Будь ласка, введіть код підтвердження."
    }
  }
}
